import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingClothesChangerConfig } from '@/data/landingConfig/landingClothesChangerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ClothesChanger } from './schemaObject';

interface Props {}
const ClothesChanger: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ClothesChanger} />
			<LandingTemplate
				data={landingClothesChangerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelClothesChanger()}
			/>
		</>
	);
};

export default ClothesChanger;
